// Codice paese ISO 3166-1 alpha-2 (come lo danno Microsoft Graph, AbuseIPDB e VirusTotal) →
// bandiera Unicode (due regional indicator). 'LAN' è il marcatore di jobs/geoEnrich.ts per gli
// IP privati: nessuna bandiera.
export function flagEmoji(code: string | null | undefined): string {
  if (!code || !/^[A-Za-z]{2}$/.test(code)) return '';
  return String.fromCodePoint(...code.toUpperCase().split('').map(c => 0x1f1e6 + c.charCodeAt(0) - 65));
}

let names: Intl.DisplayNames | null = null;
try { names = new Intl.DisplayNames(['en'], { type: 'region' }); } catch { names = null; }

export function countryName(code: string | null | undefined): string {
  if (!code || code === 'LAN') return '';
  try { return names?.of(code.toUpperCase()) || code; } catch { return code; }
}

// "🇨🇳 CN" con il nome completo nel title, oppure stringa vuota se sconosciuto/LAN.
export function countryTag(code: string | null | undefined): { text: string; title: string } | null {
  if (!code || code === 'LAN') return null;
  return { text: `${flagEmoji(code)} ${code.toUpperCase()}`.trim(), title: countryName(code) };
}
